import React from 'react';
import { useSpecSheetField } from '../../../../../queries/useSpecSheetField';
import { TextBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';

interface KitchenProps {
    readOnly?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Kitchen: React.FC<KitchenProps> = ({ readOnly = false, propertyGuid, isReview = false }) => {
    const [kitchen, setKitchen] = useSpecSheetField(
        propertyGuid,
        (s) => s.values?.['Additional Features']?.['Kitchen'] ?? '',
        (s, v) => ({ ...s, values: { ...s.values, 'Additional Features': { ...s.values?.['Additional Features'], Kitchen: v } } })
    );
    const label = 'Kitchen';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={kitchen}
                />
            ) : (
                <TextBox
                    value={kitchen ?? ''}
                    onChange={(value) => setKitchen(value)}
                    label={label}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
